<template>
	<div class="global_cta">
		<div class="container">
			<div class="inner">
				<a
					class='cta'
					v-if="parsedCta"
					:href="parsedCta.url"
					:target="parsedCta.url"
					:title="parsedCta.title"
					v-html="parsedCta.title"
				></a>

				<a
					class='phone'
					v-if="parsedPhone"
					:href="parsedPhone.url"
					:title="parsedPhone.title"
					target="_blank"
				>
					<svg
						width="640"
						height="640"
						viewBox="0 0 640 640"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M620 103.333C620 388.68 388.68 620 103.333 620C90.4593 620 77.6953 619.53 65.0573 618.603C50.554 617.54 43.302 617.01 36.701 613.21C31.2337 610.063 26.0487 604.483 23.3083 598.8C20 591.94 20 583.937 20 567.933V474.023C20 460.563 20 453.833 22.215 448.067C24.1717 442.97 27.3497 438.433 31.47 434.853C36.1343 430.8 42.4587 428.5 55.107 423.9L162.002 385.03C176.718 379.68 184.076 377.003 191.057 377.457C197.212 377.857 203.136 379.96 208.169 383.527C213.876 387.57 217.904 394.283 225.961 407.713L253.333 453.333C341.663 413.33 413.27 341.63 453.333 253.333L407.713 225.961C394.283 217.904 387.57 213.876 383.527 208.169C379.96 203.136 377.857 197.212 377.457 191.057C377.003 184.076 379.68 176.718 385.03 162.002L423.9 55.107C428.5 42.4587 430.8 36.1343 434.853 31.47C438.433 27.3497 442.97 24.1717 448.067 22.215C453.833 20 460.563 20 474.023 20H567.933C583.937 20 591.94 20 598.8 23.3083C604.483 26.0487 610.063 31.2337 613.21 36.701C617.01 43.3023 617.54 50.554 618.603 65.0577C619.53 77.6953 620 90.4593 620 103.333Z"
							stroke="black"
							stroke-width="40"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
					</svg>

					<span v-html="parsedPhone.title"></span></a>

				<a
					class='email'
					v-if="parsedEmail"
					:href="parsedEmail.url"
					:title="parsedEmail.title"
					target="_blank"
				>

					<svg
						width="640"
						height="508"
						viewBox="0 0 640 508"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M53.3333 454L220 254M586.667 454L420 254M20 120.667L260.833 281.22C282.217 295.477 292.907 302.607 304.463 305.373C314.677 307.823 325.323 307.823 335.537 305.373C347.093 302.607 357.783 295.477 379.167 281.22L620 120.667M126.667 487.333H513.333C550.67 487.333 569.34 487.333 583.6 480.067C596.143 473.677 606.343 463.477 612.733 450.933C620 436.673 620 418.003 620 380.667V127.333C620 89.9966 620 71.328 612.733 57.0673C606.343 44.523 596.143 34.3243 583.6 27.933C569.34 20.6666 550.67 20.6666 513.333 20.6666H126.667C89.33 20.6666 70.6613 20.6666 56.4007 27.933C43.8563 34.3243 33.6577 44.523 27.2663 57.0673C20 71.328 20 89.9963 20 127.333V380.667C20 418.003 20 436.673 27.2663 450.933C33.6577 463.477 43.8563 473.677 56.4007 480.067C70.6613 487.333 89.3297 487.333 126.667 487.333Z"
							stroke="black"
							stroke-width="40"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
					</svg>

					<span v-html="parsedEmail.title"></span>

				</a>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		global_cta: {},
		global_phone: {},
		global_email: {},
	},

	computed: {
		parsedCta() {
			if (this.global_cta) {
				return JSON.parse(this.global_cta);
			} else {
				return null;
			}
		},

		parsedPhone() {
			if (this.global_phone) {
				return JSON.parse(this.global_phone);
			} else {
				return null;
			}
		},

		parsedEmail() {
			if (this.global_email) {
				return JSON.parse(this.global_email);
			} else {
				return null;
			}
		},
	},

	watch: {},

	methods: {},

	components: {},

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.global_cta {
	.inner {
		grid-column: 1 / span 12;
		display: grid;
		grid-template-columns: 2fr 1fr 1fr;
		gap: 16px;

		@media (max-width: $mobile-xl) {
			grid-template-columns: repeat(4, 1fr);
			grid-template-rows: 1fr 1fr;
		}

		a {
			background: var(--orange);
			padding: 10px 40px;
			text-transform: capitalize;
			text-decoration: none;
			transition: 0.2s ease all;
			font-size: 20px;
			line-height: 30px;
			color: var(--white);
			text-align: center;
			width: calc(100% - 80px);
			display: flex;
			justify-content: center;
			align-items: center;

			&.cta {
				@media (max-width: $mobile-xl) {
					grid-column: span 4;
				}
			}

			&.phone {
				@media (max-width: $mobile-xl) {
					grid-column: span 2;
				}
			}

			&.email {
				@media (max-width: $mobile-xl) {
					grid-column: span 2;
				}
			}

			svg {
				height: 20px;
				width: 20px;
				margin-right: 10px;

				path {
					stroke: var(--white);
				}
			}

			span {
				font: inherit;
			}

			&:hover {
				background: var(--purple);
				color: var(--white);
				transition: 0.2s ease all;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/GlobalCta.vue